import {
  List,
  Datagrid,
  TextField,
  DateField,
  ArrayField,
  SingleFieldList,
  ChipField,
  BooleanField
} from "react-admin";
import GroupButtons from "../../components/group-buttons";
import CustomFilterEnterpriseAdmin from "../../filter/custom-filter-enterprise-admin";
import CustomListDefaultToolbar from "../../ui/custom-list-default-toolbar";
import EnterpriseAdminExporter from "../../exporter/enterprise-admin-exporter";
import ButtonDetails from "../../ui/button-details";
import ButtonEdit from "../../ui/button-edit";

const EnterpriseAdminList = (props) => (
  <List
    title="Usuários Admin Empresa"
    sort={{ field: "id", order: "DESC" }}
    filters={CustomFilterEnterpriseAdmin}
    exporter={EnterpriseAdminExporter}
    actions={<CustomListDefaultToolbar />}>
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="enterprise_name" label="Empresa" sortable={false} />
      <TextField source="name" label="Nome" sortable={false} />
      <TextField source="email" label="E-mail" sortable={false} />
      <ArrayField label="Permissões" source="permissions" sortable={false} fieldKey="uuid">
        <SingleFieldList
          linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <BooleanField source="is_master" label="Master" sortable={false} />
      <BooleanField source="active" label="Ativo" sortable={false} />
      <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} showTime />
      <GroupButtons>
        <ButtonDetails />
        <ButtonEdit />
      </GroupButtons>
    </Datagrid>
  </List>
);

export default EnterpriseAdminList;
